import type { ProductInfo, SubscriptionView } from "../api/accountApi";

export function formatPeriodEnd(ts: number | null, month: "short" | "long" = "short"): string | null {
  if (!ts) return null;
  return new Date(ts * 1000).toLocaleDateString("de-DE", {
    year: "numeric",
    month,
    day: "numeric",
  });
}

/** Numeric date (24.11.2026), set in the data face like a serial line. */
export function formatDay(ts: number | null): string | null {
  if (!ts) return null;
  return new Date(ts * 1000).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export function productLabel(code: string | null): string {
  if (code === "advisor") return "Capital Pilot Advisor";
  if (code === "customer") return "Capital Pilot Basis";
  if (code === "customer_plus") return "Capital Pilot Plus";
  if (code === "customer_premium") return "Capital Pilot Premium";
  return "Kein Produkt";
}

export function subscriptionStatus(status: string | null, entitled: boolean): string {
  if (status === "active") return "Aktiv";
  if (status === "trialing") return "Testphase";
  if (status === "past_due") return "Zahlung offen";
  if (status === "canceled") return "Beendet";
  if (entitled) return "Freigeschaltet";
  return "Nicht aktiv";
}

export function includedPercent(used: number, budget: number): number {
  if (budget <= 0) return 0;
  return Math.min(100, Math.round((used / budget) * 100));
}

export function formatUsageMonth(monthUtc: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(monthUtc);
  if (!match) return monthUtc;
  return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1)).toLocaleDateString(
    "de-DE",
    { month: "long", year: "numeric", timeZone: "UTC" },
  );
}

export function limitLine(limit: number | null | undefined, one: string, many: string): string {
  if (limit == null) return `${many} unbegrenzt`;
  return `${limit} ${limit === 1 ? one : many}`;
}

export function productReady(sub: SubscriptionView, code: string): boolean {
  return (
    sub.stripe_configured &&
    sub.products.some((product) => product.code === code && product.price_configured)
  );
}

export function findProduct(sub: SubscriptionView, code: string): ProductInfo | undefined {
  return sub.products.find((product) => product.code === code);
}

export function billingLine(sub: Pick<SubscriptionView, "cancel_at_period_end" | "current_period_end" | "status" | "entitled">): string {
  const end = formatPeriodEnd(sub.current_period_end, "long");
  if (sub.cancel_at_period_end && end) return `Endet am ${end}`;
  if (end) return `Nächste Abrechnung ${end}`;
  return subscriptionStatus(sub.status, sub.entitled);
}
